import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { createLocalizedHours } from '@mews/business-components';
import { TimeService, useDateTimeLocalizationInfo } from '@mews/framework';
import { createOption } from '../../common';

export interface HoursOptionsProps {
    maxValue?: string;
    minValue?: string;
}

export const useHoursOptions = ({ minValue, maxValue }: HoursOptionsProps) => {
    const localizationInfo = useDateTimeLocalizationInfo();

    const minTime = minValue ? TimeService.fromShortString(minValue, localizationInfo) : TimeService.parse('00:00:00');
    const maxTime = maxValue ? TimeService.fromShortString(maxValue, localizationInfo) : TimeService.parse('23:00:00');

    return pipe(
        localizationInfo,
        createLocalizedHours,
        array.filter(
            ({ time }) => TimeService.isLessOrEqual(time, maxTime) && TimeService.isGreaterOrEqual(time, minTime)
        ),
        array.map(({ value }) => createOption({ label: value, value }))
    );
};
